import type { Form } from '../../../../common/types/form';
import type { Child } from '../../../../common/types/child';

const unsubscribeDataForm: Form<Child> = {
  key: 'unsubscribeData',
  title: 'Abmeldung',
  fields: [
    {
      key: 'unsubscribeSchool',
      label: 'Schule / KiGa',
      fieldTypes: 'checkbox',
    },
    {
      key: 'unsubscribeAfterSchoolCare',
      label: 'Mittagsbetreuung / Hort',
      fieldTypes: 'checkbox',
    },
    {
      key: 'unsubscribeHotMeal',
      label: 'Anbieter Mittagessen',
      fieldTypes: 'checkbox',
    },
    {
      key: 'unsubscribeYouthWelfareOffice',
      label: 'Jugendamt',
      fieldTypes: 'checkbox',
    },
    {
      key: 'unsubscribeEarlyIntervention',
      label: 'Frühförderung',
      fieldTypes: 'checkbox',
    },
  ],
};

export default unsubscribeDataForm;
